import { useEffect, useState } from 'react'
import css from './Checkbox.module.scss'

export default function Checkbox({
	label,
	onChange,
	defaultChecked,
	value,
	disabled,
	name,
	onClick,
	id = name,
}) {
	return (
		<div className={css['box']}>
			<input
				name={name}
				type='checkbox'
				// I'm not sure about this
				// defaultChecked={defaultChecked}
				// defaultChecked={checked || defaultChecked || false}
				onChange={onChange}
				id={id}
				checked={value}
				disabled={disabled}
				onClick={onClick}
			/>
			<label htmlFor={id}>{label}</label>
		</div>
	)
}
